var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodeAppsPopUpLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 17,
    viewBox: "0 0 115 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5751 0H67.5231L55.7678 16.1308L60.3419 16.144L67.5732 5.85305V16.1374H71.1061V0H67.5751Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.306 7.03463V0H101.699V5.11025L104.22 7.51076V7.51785L109.194 12.6097H105.353L101.866 9.11315V16.1374H114.305V12.604L113.505 11.7784L113.519 11.7633L105.326 3.53008H110.88L114.306 7.03463Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6607 0H87.2421V16.1374H90.94V3.53008H96.6555V3.61093L93.1254 7.09231V12.1283L96.6555 8.64884V8.65877L100.186 5.11025V0H96.6607Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0364 0H72.6178V16.1374H76.3157V3.53008H82.0312V3.58398L78.5011 7.03841V12.1283L85.5613 5.11025V0H82.0364Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4373 4.37076L26.8959 0.0505918V0H17.482L13.9203 4.37076L13.89 11.7732L17.4655 16.1355H26.8959V16.0665L30.4359 11.7832L30.4373 4.37076ZM17.482 12.6073V3.53008H26.8954V12.6082L17.482 12.6073Z",
    fill: "#3399FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5457 3.53008L64.9831 0H47.405V16.1374H53.5517L55.9877 12.6073H50.9332V9.74957H58.4255L60.8629 6.21949H50.9337V3.53008H62.5457Z",
    fill: "#3399FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9435 5.11025V0H0V3.53008H9.41339V3.60384L3.54616 9.41197L9.35807 16.1374H13.8849L8.44742 9.55997L12.9435 5.11025Z",
    fill: "#3399FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4414 0H31.9386V3.53008H42.3605V12.6082H31.9386V16.1374H42.4414L46.022 11.7784L45.9951 4.36556L42.4414 0Z",
    fill: "#3399FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodeAppsPopUpLogo);
export default __webpack_public_path__ + "static/media/RodeAppsPopUpLogo.4a248f21.svg";
export { ForwardRef as ReactComponent };